/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "car-bedrijfswagen-eb538d1b--sprite",
  "use": "car-bedrijfswagen-eb538d1b--sprite-usage",
  "viewBox": "0 0 47 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 47 24\" id=\"car-bedrijfswagen-eb538d1b--sprite\"><path d=\"M40 9h1a5 5 0 015 5v4a1 1 0 01-1 1h-5m0-10l-5.7-7.6a1 1 0 00-.8-.4h-4M40 9h-9.5a1 1 0 01-1-1V1M40 19a4 4 0 01-8 0m8 0a4 4 0 00-8 0m0 0H14m0 0a4 4 0 01-8 0m8 0a4 4 0 00-8 0m0 0H2a1 1 0 01-1-1V2a1 1 0 011-1h27.5\" stroke=\"#000\" stroke-width=\"2\" /><g opacity=\".2\" fill=\"#000\"><path d=\"M21.991 6.024c-.388.044-.723.18-1.034.373a4.842 4.842 0 00-1.146 1.024c-.383.457-.748.928-1.118 1.396-.29.368-.585.733-.944 1.045-.438.381-.936.64-1.537.693a2.236 2.236 0 01-1.463-.358c-.447-.293-.785-.686-1.076-1.117-.027-.04-.054-.059-.106-.058-.495.001-.989 0-1.483-.001L12 9.024l.031.072a7.4 7.4 0 001 1.464c.383.44.83.806 1.366 1.068a3.65 3.65 0 002.096.341 3.783 3.783 0 001.224-.364c.575-.284 1.048-.688 1.473-1.15.418-.454.774-.952 1.138-1.446.232-.314.457-.633.727-.92.248-.265.536-.475.898-.576.042-.011.047-.033.047-.068a302.1 302.1 0 01-.009-1.127v-.294zM14.524 7.73c.497 0 .902-.386.903-.86 0-.48-.407-.87-.906-.87-.495 0-.9.39-.902.862 0 .484.4.868.905.868z\" /><path d=\"M17.677 7.73c.503.001.902-.38.904-.86.002-.482-.401-.87-.904-.87-.494 0-.897.387-.898.863-.002.482.396.866.898.867z\" /></g><path d=\"M36.408 15L40 9l-11-.5V16h4.19M1 11h3v2H1.5M46 12h-3l-3-3\" stroke=\"#000\" stroke-width=\".75\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
